/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  GenerationLog,
  GenerationLogListParams,
  PaginatedGenerationLogList,
} from "../../models";

import { customInstance } from "../../custom-instance";
import type { ErrorType } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Read-only ViewSet for Generation Log monitoring.

Endpoints:
    GET /api/generation-logs/ - List all logs for user's playlists
    GET /api/generation-logs/{id}/ - Get log details

Optimization:
    - Select_related for playlist and track to avoid N+1
    - Defer large metadata field to reduce transfer size on list
 */
export const generationLogList = (
  params?: GenerationLogListParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PaginatedGenerationLogList>(
    { url: `/api/generation-logs/`, method: "GET", params, signal },
    options,
  );
};

export const getGenerationLogListQueryKey = (
  params?: GenerationLogListParams,
) => {
  return [`/api/generation-logs/`, ...(params ? [params] : [])] as const;
};

export const getGenerationLogListQueryOptions = <
  TData = Awaited<ReturnType<typeof generationLogList>>,
  TError = ErrorType<unknown>,
>(
  params?: GenerationLogListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof generationLogList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGenerationLogListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof generationLogList>>
  > = ({ signal }) => generationLogList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof generationLogList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GenerationLogListQueryResult = NonNullable<
  Awaited<ReturnType<typeof generationLogList>>
>;
export type GenerationLogListQueryError = ErrorType<unknown>;

export function useGenerationLogList<
  TData = Awaited<ReturnType<typeof generationLogList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GenerationLogListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof generationLogList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof generationLogList>>,
          TError,
          Awaited<ReturnType<typeof generationLogList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGenerationLogList<
  TData = Awaited<ReturnType<typeof generationLogList>>,
  TError = ErrorType<unknown>,
>(
  params?: GenerationLogListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof generationLogList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof generationLogList>>,
          TError,
          Awaited<ReturnType<typeof generationLogList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGenerationLogList<
  TData = Awaited<ReturnType<typeof generationLogList>>,
  TError = ErrorType<unknown>,
>(
  params?: GenerationLogListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof generationLogList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGenerationLogList<
  TData = Awaited<ReturnType<typeof generationLogList>>,
  TError = ErrorType<unknown>,
>(
  params?: GenerationLogListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof generationLogList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGenerationLogListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Read-only ViewSet for Generation Log monitoring.

Endpoints:
    GET /api/generation-logs/ - List all logs for user's playlists
    GET /api/generation-logs/{id}/ - Get log details

Optimization:
    - Select_related for playlist and track to avoid N+1
    - Defer large metadata field to reduce transfer size on list
 */
export const generationLogRetrieve = (
  id: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GenerationLog>(
    { url: `/api/generation-logs/${id}/`, method: "GET", signal },
    options,
  );
};

export const getGenerationLogRetrieveQueryKey = (id?: number) => {
  return [`/api/generation-logs/${id}/`] as const;
};

export const getGenerationLogRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof generationLogRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof generationLogRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGenerationLogRetrieveQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof generationLogRetrieve>>
  > = ({ signal }) => generationLogRetrieve(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof generationLogRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GenerationLogRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof generationLogRetrieve>>
>;
export type GenerationLogRetrieveQueryError = ErrorType<unknown>;

export function useGenerationLogRetrieve<
  TData = Awaited<ReturnType<typeof generationLogRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof generationLogRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof generationLogRetrieve>>,
          TError,
          Awaited<ReturnType<typeof generationLogRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGenerationLogRetrieve<
  TData = Awaited<ReturnType<typeof generationLogRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof generationLogRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof generationLogRetrieve>>,
          TError,
          Awaited<ReturnType<typeof generationLogRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGenerationLogRetrieve<
  TData = Awaited<ReturnType<typeof generationLogRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof generationLogRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGenerationLogRetrieve<
  TData = Awaited<ReturnType<typeof generationLogRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof generationLogRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGenerationLogRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
